import { render, staticRenderFns } from "./LibrosSuc.vue?vue&type=template&id=4f560304&scoped=true&"
import script from "./LibrosSuc.vue?vue&type=script&lang=js&"
export * from "./LibrosSuc.vue?vue&type=script&lang=js&"
import style0 from "./LibrosSuc.vue?vue&type=style&index=0&id=4f560304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f560304",
  null
  
)

export default component.exports